import { EfsMelcoEfsModelsSchemaListItem } from "melco-shared-logic";
import { DataMappingAttribute } from "../../hooks/inputFormats/useDataMappings";
import { useAdvancedOptions } from "../../hooks/settings/useAdvancedOptions";
import { SelectColorCollection } from "./SelectColorCollection";
import { SelectDataSource } from "./SelectDataSource";
import { SelectFontCollection } from "./SelectFontCollection";
import { SelectSourceModifier } from "./SelectSourceModifier";

type AttributesProps = {
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
  attribute: DataMappingAttribute;
};

export const Attributes: React.FC<AttributesProps> = ({
  dataAssignments,
  attribute,
}) => {
  const isAdvancedOptionsEnabled = useAdvancedOptions();

  const isColorCollectionSelectable = attribute === "_color";

  const isFontCollectionSelectable = attribute === "_font";

  return (
    <>
      <SelectDataSource
        dataAssignments={dataAssignments}
        attribute={attribute}
        name="dataSource"
      />

      {isColorCollectionSelectable && (
        <SelectColorCollection attribute={attribute} />
      )}

      {isFontCollectionSelectable && (
        <SelectFontCollection attribute={attribute} />
      )}

      {isAdvancedOptionsEnabled && (
        <SelectSourceModifier name={`${attribute}.sourceModifier`} />
      )}
    </>
  );
};
